<template>
	<div class="MarkerPopup">
		<div class="MarkerPopup-loading"></div>
		<div class="MarkerPopup-contents" v-if="projectMarker != null">
			<h3>
				<a target="_blank" :href="projectMarker.company != null ? `https://regio.gripp.com/d/company/edit/${projectMarker.company.id}` : ''">
					{{ fullname }}
				</a>
			</h3>
			<div class="MarkerPopup-address-amount">
				<div class="MarkerPopup-address" v-if="projectMarker.company != null">
					<div>{{ projectMarker.company.visitingaddress_street }}
						{{ projectMarker.company.visitingaddress_streetnumber }}
					</div>
					<div v-if="projectMarker.company.visitingaddress_zipcode">
						{{ projectMarker.company.visitingaddress_zipcode }}
					</div>
					<div v-if="projectMarker.company.visitingaddress_city">
						{{ projectMarker.company.visitingaddress_city }}
					</div>
				</div>
				<span class="amount"
					  v-if="projectMarker.projectLines != null && projectMarker.projectLines.length > 0"
				>{{
						projectMarker.projectLines[0].amount + projectMarker.projectLines[0].unit
					}}
				</span>
			</div>
			<div class="MarkerPopup-appointment" v-if="mapType === 'uitvoering'">
				<div class="appointment-item">
					<span>Opdrachtnummer:</span>
					<a :href="`https://regio.gripp.com/d/project/view/${projectMarker.id}`" target="_blank">{{ projectMarker.number }}</a>
				</div>
				<div class="appointment-item">
					<span>Opdrachtdatum:</span>
					<span>{{ parseDate(projectMarker.startdate) }}</span>
				</div>
				<div class="appointment-item" v-if="projectMarker.company != null && projectMarker.company.customfield_datumaantafel != null && projectMarker.company.customfield_datumaantafel !== ''">
					<span>Datum aan tafel:</span>
					<span>{{ parseDate(projectMarker.company.customfield_datumaantafel) }}</span>
				</div>
			</div>
			<div class="MarkerPopup-appointment" v-if="mapType === 'execution-appointments' && originalAppointment != null">
				<div class="appointment-item">
					<span>Oorspronkelijke uitvoerdatum:</span>
					<span>{{ parseDate(originalAppointment.date) }}</span>
				</div>
				<div class="appointment-item">
					<span>Tijd:</span>
					<span>{{ parseTime(originalAppointment.planned_start_time) }} - {{ parseTime(originalAppointment.planned_end_time) }}</span>
				</div>
				<div class="appointment-item">
					<span>Uitvoerende ploeg:</span>
					<span>{{ originalAppointment.uitvoerende_ploeg }}</span>
				</div>
			</div>
			<div class="MarkerPopup-appointment" v-if="mapType === 'execution-appointments' && mainAppointment != null">
				<div class="appointment-item">
					<span>Uitvoerdatum:</span>
					<span>{{ parseDate(mainAppointment.date) }}</span>
				</div>
				<div class="appointment-item">
					<span>Tijd:</span>
					<span>{{ parseTime(mainAppointment.planned_start_time) }} - {{ parseTime(mainAppointment.planned_end_time) }}</span>
				</div>
				<div class="appointment-item">
					<span>Uitvoerende ploeg:</span>
					<span>{{ mainAppointment.uitvoerende_ploeg }}</span>

				</div>
			</div>
			<div class="MarkerPopup-appointment" v-if="mapType === 'execution-appointments'">
				<div class="appointment-item">
					<span>Opdrachtnummer:</span>
					<a :href="`https://regio.gripp.com/d/project/view/${projectMarker.id}`" target="_blank">{{ projectMarker.number }}</a>
				</div>
				<div class="appointment-item">
					<span>Opdrachtdatum:</span>
					<span>{{ parseDate(projectMarker.startdate) }}</span>
				</div>
				<div class="appointment-item" v-if="projectMarker.company != null && projectMarker.company.customfield_datumaantafel != null && projectMarker.company.customfield_datumaantafel !== ''">
					<span>Datum aan tafel:</span>
					<span>{{ parseDate(projectMarker.company.customfield_datumaantafel) }}</span>
				</div>
			</div>
			<div class="MarkerPopup-appointment" v-if="mapType === 'execution-appointments' && mainAppointment != null && mainAppointment.hoogwerker_date != null &&
				mainAppointment.hoogwerker_date !== ''">
				<div class="appointment-item">
					<span>Hoogwerker:</span>
					<span>{{ parseDate(mainAppointment.hoogwerker_date) }}</span>
				</div>
				<div class="appointment-item">
					<span>Bevestigd Peinemann:</span>
					<ToggleField name="hoogwerk_uitvoering_check" :checked="shouldHoogwerkerBeChecked" @onchange="changeHoogwerkerCheck"/>
				</div>
			</div>
			<div class="MarkerPopup-appointment" v-if="mapType === 'execution-appointments' && mainAppointment != null">
				<div class="appointment-item" v-if="mainAppointment.createdByUser != null">
					<span>Ingepland:</span>
					<span>{{ mainAppointment.createdByUser.display_name }}</span>
				</div>
				<div class="appointment-item">
					<span>Ingepland op:</span>
					<span>{{ parseDate(mainAppointment.created_at) }}</span>
				</div>
			</div>
		</div>
		<a class="MarkerPopup-phone" :href="'tel:' + phoneNumber" v-if="phoneNumber">
			<PhoneIcon/>
			{{ phoneNumber }}
		</a>
		<div class="MarkerPopup-lastupdated" v-if="projectMarker.lastTimeline != null">
			{{ projectMarker.lastTimeline.date }}
		</div>
		<div class="MarkerPopup-lastTimeline" v-if="projectMarker.lastTimeline != null">
			{{ projectMarker.lastTimeline.message }}
		</div>
		<div class="MarkerPopup-additional">
			<ul v-if="projectMarker.projectLines != null" class="MarkerPopup-additional-projects">
				<li class="projectLine" v-for="projectLine in projectMarker.projectLines" v-if="![45, 64, 102, 52, 320, 76, 308, 309, 61, 321, 56, 64, 332].includes(projectLine.product_id)">
					<span class="projectLineItem">{{
							projectLine.searchname
						}}
					</span>
					<span>{{ projectLine.amount + projectLine.unit }}</span>
				</li>
			</ul>
		</div>
		<div class="MarkerPopup-actions" v-if="shouldShowHistoricActions() === false">
			<Button :disabled="isLoading" v-if="mapType === 'uitvoering'" @click="onClickCreateAppointment(false)">AFSPRAAK</Button>
			<Button :disabled="isLoading" v-if="mapType === 'execution-appointments'" @click="onClickCreateAppointment(true)">
				VERPLAATSEN
			</Button>
			<DropdownButton v-if="mapType === 'execution-appointments'">
				<template v-slot:button>AFZEGGEN</template>
				<Button :disabled="isLoading" @click="onClickCancelProject">Annuleren</Button>
				<Button :disabled="isLoading" @click="onClickRescheduleProject($event)">Opnieuw Inplannen</Button>
			</DropdownButton>
			<DropdownButton v-if="mapType === 'execution-appointments'">
				<template v-slot:button>PLOEG WIJZIGEN</template>
				<Button :disabled="isLoading" v-for="van in vans" :key="van.id" @click="onClickReassignAppointment(van.id)">{{van.display_name}}</Button>
			</DropdownButton>
			<Button :disabled="isLoading" v-if="mapType === 'uitvoering'" @click="onClickGeenGehoor($event)">GEEN GEHOOR</Button>
			<Button :disabled="isLoading" @click="onClickCreateNote">NOTITIE</Button>
			<Button :disabled="isLoading" v-if="mapType === 'uitvoering'" @click="onClickCancelProject">ANNULEREN</Button>
		</div>
		<div class="MarkerPopup-actions" v-if="mapType === 'execution-appointments' && shouldShowHistoricActions()">
			<Button :disabled="isLoading" @click="onClickSupport">SUPPORT</Button>
			<a :class="{disabled:isLoading}" v-if="mainAppointment" class="Button" target="_blank" :href="'/uitvoering-afspraken/' + mainAppointment.id">UITVOERING</a>
		</div>
		<a v-if="file != null" :href="'/files/getById?file_id=' + file.id" target="_blank" class="image">
			<img class="marker-image" :src="'/files/getById?height=600&width=600&file_id=' + file.id" :alt="file.file_name">
		</a>
	</div>
</template>

<script>
import Button from "@/components/Button";
import CancelProject from "@/components/CancelProject";
import Collapsible from "@/components/Collapsible";
import CreateNote from "@/components/CreateNote";
import DropdownButton from "@/components/DropdownButton";
import ExecutionAppointmentCreateModal from "@/components/ExecutionAppointmentCreateModal";
import { client } from "@/store";
import { PhoneIcon } from "vue-feather-icons";
import { mapActions, mapGetters, mapState } from "vuex";
import { parseDate, parseTime } from "../utils";
import ToggleField from "./ToggleField";
import CreateSupportTicketModal from "@/components/CreateSupportTicketModal";

export default {
	components: {
		ToggleField,
		Button,
		DropdownButton,
		ExecutionAppointmentCreateModal,
		PhoneIcon,
		Collapsible
	},

	props: {
		data: Object,
		filter: String,
		projectType: String
	},

	data() {
		return {
			projectMarker: this.data,
			file: null,
			vans: [],
			mainAppointment: null,
			isSupport: false,
			originalAppointment: null
		};
	},

	beforeMount() {
		this.fetchAdditionalInfo();
	},

	computed: {
		...mapGetters({
			allowedTo: "auth/allowedTo",
			getProjectMarkerById: "projects/getProjectMarkerById"
		}),

		...mapState("map", {
			mapType: "mapType"
		}),

		...mapState({
			isLoading: "loading"
		}),

		...mapState("data", {
			agents: "agents"
		}),

		phoneNumber() {
			if (this.projectMarker == null || this.projectMarker.company == null) {
				return null;
			}

			if (!this.empty(this.projectMarker.company.phone)) {
				return this.projectMarker.company.phone;
			} else if (!this.empty(this.projectMarker.company.mobile)) {
				return this.projectMarker.company.mobile
			} else {
				return null;
			}
		},

		fullname() {
			if (this.projectMarker == null || this.projectMarker.company == null) {
				return "";
			}
			const salutations = {
				1: "Dhr.",
				2: "Mevr.",
				3: "Dhr/Mevr."
			};

			let name = [];
			if (!this.empty(this.projectMarker.company.salutation)) name.push(salutations[parseInt(this.projectMarker.company.salutation)]);
			if (!this.empty(this.projectMarker.company.initials)) name.push(this.projectMarker.company.initials);
			if (!this.empty(this.projectMarker.company.infix)) name.push(this.projectMarker.company.infix);
			if (!this.empty(this.projectMarker.company.lastname)) name.push(this.projectMarker.company.lastname);
			if (name.length === 0 || (name.length === 1 && !this.empty(this.projectMarker.company.salutation))) {
				name.push(this.projectMarker.company.companyname);
			}

			return name.join(" ");
		},

		shouldHoogwerkerBeChecked() {
			if (this.projectMarker.customfield_supportbevestigdpeinemann != null && this.projectMarker.customfield_supportbevestigdpeinemann !== "") {
				return this.projectMarker.customfield_supportbevestigdpeinemann === '1';
			} else {
				return this.projectMarker.customfield_hoogwerkeruitvoeringcheck === '1';
			}
		}
	},

	methods: {
		...mapActions({
			getProjectById: "projects/getProjectById",
			refreshProjectMapMarker: "projects/refreshProjectMapMarker",
			getFile: "files/fetchFiles",
			createNote: "projects/createNote",
			createGeenGehoor: "projects/createGeenGehoor",
			cancelUitvoering: "projects/cancelUitvoering",
			reassignProject: "projects/reassignProject",
			updateProject: "projects/updateProject",
			setLoading: "map/setLoading",
			setIdle: "map/setIdle"
		}),

		getVans() {
			let roles;
			if(this.projectMarker.additionalData != null) {
				switch (this.projectMarker.additionalData.product_type) {
					case 'FTX1':
						roles = ["FTX1", "SUPPORT"];
						break;
					case 'THERMOFOAM':
						roles = ["THERMO_FOAM", "SUPPORT"];
						break;
					case 'VLOERISOLATIE':
						roles = ["FLOOR", "SUPPORT"];
						break;
					case 'BODEMISOLATIE':
						roles = ["GROUND", "SUPPORT"];
						break;
					case 'IMPREGNEREN':
						roles = ["IMPREGNEREN", "SUPPORT"];
						break;
					default:
						roles = ["SUPPORT"];
				}
			} else {
				// todo delete this legacy code
				switch (this.projectMarker.gripp_projectphase_id) {
					case 35:
						roles = ["GROUND", "SUPPORT"];
						break;
					case 28:
						roles = ["THERMO_FOAM", "SUPPORT"];
						break;
					case 54:
						roles = ["FTX1", "SUPPORT"];
						break;
					case 55:
					case 58:
						roles = ["FLOOR", "SUPPORT"];
						break;
					default:
						roles = ["SUPPORT"];
				}
			}

			client.query(`
				query($roles: [String]) {
					users(roles: $roles) {
						id
						display_name
						username
					}
				}`,
				{roles: roles}
			).then(result => {
				this.vans = result.users.filter(user => this.mainAppointment != null && user.id !== parseInt(this.mainAppointment.user_id));
			}).catch(error => {
				console.log(error);
			});
		},

		onClickCreateAppointment(isReschedule) {
			this.$modal.show(ExecutionAppointmentCreateModal, {
				projectMarker: this.projectMarker,
				file: this.file,
				isReschedule: isReschedule,
				isSupport: this.isSupport
			}, {
				classes: "modal",
				adaptive: true,
				scrollable: true,
				width: "100%",
				height: "auto",
				maxWidth: 1200
			});
		},

		onClickGeenGehoor(button) {
			button.disable();
			this.createGeenGehoor(this.projectMarker.id).then(() => {
				this.getProjectById({id: this.projectMarker.id});
				button.enable();
				this.$events.emit("map/closePopup");
			}).catch(() => {
				button.enable();
			});
		},

		fetchAdditionalInfo() {
			this.setLoading();
			this.getProjectById({id: this.data.id}).then(project => {
				this.projectMarker = project;
				const originalAppointment = project.appointments.find(appointment => appointment.type === "PROJECT/UITVOERENDE_PLOEG");
				this.mainAppointment = project.appointments.reverse().find(appointment => appointment.type === "PROJECT/UITVOERENDE_PLOEG");
				if (originalAppointment != null && originalAppointment !== this.mainAppointment) {
					this.originalAppointment = originalAppointment;
					this.originalAppointment.uitvoerende_ploeg = this.projectMarker.customfield_uitvoerendeploeg;
				}
				if (this.mainAppointment != null) {
					if (this.projectMarker.customfield_uitvoeringservicedatum != null && this.projectMarker.customfield_uitvoeringservicedatum !== '') {
						this.isSupport = true;

						this.mainAppointment.hoogwerker_date = this.projectMarker.customfield_supporthoogwerker;
						this.mainAppointment.uitvoerende_ploeg = this.projectMarker.customfield_uitvoeringserviceploeg;
					} else {
						this.mainAppointment.hoogwerker_date = this.projectMarker.customfield_hoogwerkeruitvoeringdatum;
						this.mainAppointment.uitvoerende_ploeg = this.projectMarker.customfield_uitvoerendeploeg;
					}
				}

				this.getFile({
					company_id: project.company.id,
					type: "sales/voorkant"
				}).then(file => {
					this.file = file[0];
					this.setIdle();
				}).catch(error => {
					console.error(error);
					this.setIdle();
				});
				this.getVans();
			});
		},

		onClickCreateNote() {
			this.$modal.show(CreateNote, {
				data: this.projectMarker.company,
				project: this.projectMarker,
				type: this.mapType === 'execution-appointments' ? 'Uitvoering-afspraak' : "Uitvoering"
			}, {
				classes: "modal",
				adaptive: true,
				scrollable: true,
				width: "100%",
				height: "auto",
				maxWidth: 600
			}, {
				"before-close": (event) => {
					this.fetchAdditionalInfo();
				}
			});
		},

		onClickRescheduleProject(button) {
			this.cancelUitvoering({
				id: this.projectMarker.id,
				reason: '',
				reschedule: true
			}).then(result => {
				button.enable();
				this.$notify({
					group: "app",
					title: "Opdracht opnieuw inplannen",
					type: "success",
					text: `De opdracht voor ${this.projectMarker.company.companyname} kan opnieuw ingepland worden`
				});
				this.refreshProjectMapMarker({id: this.projectMarker.id});
				this.$events.emit("map/closePopup");
				this.$emit("close");
			}).catch((error) => {
				button.enable();
				this.$notify({
					group: "app",
					title: "Opdracht opnieuw inplannen",
					type: "error",
					text: error
				});
			});
		},

		onClickCancelProject() {
			this.$modal.show(CancelProject, {data: this.projectMarker.company, project: this.projectMarker}, {
				classes: "modal",
				adaptive: true,
				scrollable: true,
				width: "100%",
				height: "auto",
				maxWidth: 600
			});
		},

		onClickReassignAppointment(userId) {
			this.reassignProject({
				id: this.projectMarker.id,
				userId: userId,
			}).then(result => {
				this.$notify({
					group: "app",
					title: "Ploeg gewijzigd",
					type: "success",
					text: `Ploeg gewijzigd voor ${this.projectMarker.company.companyname}`
				});
				this.refreshProjectMapMarker({id: this.projectMarker.id});
				this.$events.emit("map/closePopup");
				this.$emit("close");
			}).catch((error) => {
				this.$notify({
					group: "app",
					title: "Ploeg wijzigen",
					type: "error",
					text: error
				});
			});
		},

		onClickSupport() {
			this.$modal.show(CreateSupportTicketModal, {
				project: this.projectMarker
			}, {
				classes: "modal",
				adaptive: true,
				scrollable: true,
				width: "100%",
				height: "auto",
				maxWidth: 1200
			});
		},

		empty(value) {
			return value == null || (typeof value === "string" && value.trim() === "");
		},

		parseDate(date) {
			return parseDate(date);
		},

		parseTime(time) {
			return parseTime(time);
		},

		changeHoogwerkerCheck(value) {
			if (!this.isSupport) {
				this.updateProject({
					id: this.projectMarker.id,
					customfield_hoogwerkeruitvoeringcheck: value
				});
			} else {
				this.updateProject({
					id: this.projectMarker.id,
					customfield_supportbevestigdpeinemann: value
				});
			}
		},

		shouldShowHistoricActions() {
			// Gilde should always show historic actions for now...
			return this.filter === "historic" || this.projectType === "gilde";
		}
	}
};
</script>

<style scoped>
.MarkerPopup-contents {
	position: relative;
}

.projectLine {
	display: flex;
	justify-content: space-between;
	flex-direction: row;
}

.marker-image {
	position: absolute;
	left: 380px;
	top: 0;
	box-shadow: 0 0 30px rgb(0 0 0 / 50%);
	height: 100%;
	z-index: -1;
}

.MarkerPopup-lastTimeline {
	text-align: center;
}

.projectLineItem {
	display: list-item;
}

.MarkerPopup-additional {
	background: #f7f9fa;
	padding: 10px 20px 20px;
	margin: 0 -20px -20px;
}

.MarkerPopup-address-amount {
	display: flex;
	justify-content: space-between;
}

.amount {
	margin-top: auto;
	font-weight: 900;
	font-size: 18px;
	color: #000000;
}

.MarkerPopup-address-amount, .MarkerPopup-appointment {
	border-bottom: 1px solid #eee;
	padding-bottom: 20px;
	margin-bottom: 0.5em;
}

.MarkerPopup-appointment:not(:first-child) {
	margin-top: 1em;
}

.appointment-item {
	display: flex;
	justify-content: space-between;
}

.MarkerPopup-actions a.disabled {
	pointer-events: none;
	cursor: default;
	opacity: 0.5;
}
</style>
